export const SAVE_STATUSES = {
  IDLE: 'IDLE',
  SAVING: 'SAVING',
  SAVED: 'SAVED',
  ERROR: 'ERROR',
} as const;

export type SaveStatus = typeof SAVE_STATUSES[keyof typeof SAVE_STATUSES];
